"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Badge = _interopRequireDefault(require("./Badge.sizes"));

var _Badge2 = _interopRequireDefault(require("./Badge.theme"));

var _styles = require("./styles");

var _excluded = ["children", "color", "disabled", "size", "theme"];
var Badge = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      color = _ref.color,
      disabled = _ref.disabled,
      size = _ref.size,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var badgeAppearance = (0, _Badge2.default)(theme.colors[color]);
  var badgeSize = (0, _Badge.default)(theme)[size];
  var appearance = 'color';

  if (disabled) {
    appearance = 'disabled';
  }

  return /*#__PURE__*/_react.default.createElement(_styles.Box, Object.assign({
    ref: ref,
    appearance: badgeAppearance[appearance],
    size: badgeSize
  }, rest), children);
});
Badge.defaultProps = {
  size: 'sm',
  color: 'primary',
  disabled: false
};

var _default = (0, _styledComponents.withTheme)(Badge);

exports.default = _default;